export default function Headline({children, className}) {
    return (
        <h1 className={`${className} flex justify-center text-white text-md sm:text-lg py-2 2xl:text-xl xl:w-[30vw]`}>{children}</h1>
    );
}

